<template>
    <div class="xx-menu">
        <slot></slot>
    </div>
</template>

<script>
// getEmpMenu 菜单接口（废弃）
// getEmpSortedMenu 菜单接口，带顶栏 已确认兼容 getEmpMenu
// getQuickMenu 快捷入口
// getHistoryMenu 历史菜单
import { fetchHornConfig } from '@osgfe/tools';
// eslint-disable-next-line import/no-unresolved
import { detectDeviceType } from '@/utils/tools';
import { ACCOUNT_TYPE } from "@/constants";
import { sendAllPageViewEventMetric } from "@/constants/log";
import { formatMenuSource, formatRenxiaoMenuSource } from '@/utils/menu';
import { menuList } from '../../api/renxiaoMenu';

import {
    getWeight, parseFirstMenuUrl, parseSecondMenuUrl, isIosMobileAndData,
} from './config';

export default {
    name: 'XxMenuProvider',
    inject: ['$$event', '$xxRouter', '$xxEvent', '$xxPlatform'],
    provide() {
        return {
            $xxMenu: this,
        };
    },
    data() {
        return {
            dataLoading: false,

            menuList: [],

            // 格式化后的菜单数据，保证只初始化一次，不然会影响性能
            menuData: [],
            // 添加映射，方便查找
            firstMenusMap: {},
            secondMenusMap: {},
            thirdMenusMap: {},
            thirdMenusUrlMap: {},

            userInfo: {
                uid: -1,
                name: '芥末用户',
            },

            pathMap: {},
            blockedUrls: [],

            activeFirstMenuId: -1,
            activeSecondMenuId: -1,
            reflectActiveSecondMenuId: -1,

            showSecondMenu: false,
            showThirdMenu: false,

            showFirstMenuIds: [],
            hideFirstMenuIds: [],

            isMobile: detectDeviceType() === 'Mobile',
        };
    },
    computed: {
        showFirstMenus() {
            // 只展示有子菜单的一级菜单
            return this.showFirstMenuIds.map((id) => this.firstMenusMap[id]).filter((topMenu) => topMenu && topMenu.subMenus && topMenu.subMenus.length > 0);
        },
        hideFirstMenus() {
            // 只展示有子菜单的一级菜单
            return this.hideFirstMenuIds.map((id) => this.firstMenusMap[id]).filter((topMenu) => topMenu && topMenu.subMenus && topMenu.subMenus.length > 0);
        },
        // 全部三级菜单
        allThirdMenusList() {
            const ret = [];
            (this.menuData || []).forEach((fMenu) => {
                // 一级
                (fMenu.subMenus || []).forEach((sMenu) => {
                    // 二级
                    (sMenu.subMenus || []).forEach((tMenu) => {
                        // 三级
                        ret.push({
                            ...tMenu,
                            renderName: [fMenu.title, sMenu.title, tMenu.title].join(' / '),
                        });
                    });
                });
            });
            return ret;
        },
        settingMenu() {
            // FIXME: "快捷操作设置" 菜单查找优化，ps，这里其实可以写死，但不利于修改
            return this.allThirdMenusList.find(({ title }) => title === '快捷操作设置');
        },
        supplierMenuList() {
            return this.$store.getters.supplierMenuList;
        },
    },
    created() {
        this.$$event.$on('$tab.click', (pageKey) => {
            const pageIndex = this.$xxRouter.loader.getPageIndexByKey(pageKey);
            if (pageIndex === -1) {
                return;
            }
            // 此处可能包括 query-string
            // /tms/schedule.html
            this.reflectActiveMenuDisplay(this.getActiveMenu(this.$xxRouter.loader.pages[pageIndex].url));
        });
        this.$$event.$on('$router.history.change', (location) => {
            this.setActiveMenusByLocation(location);
        });

        // 页面打开后的初始化动作
        this.$$event.$on('$menu.load', (err) => {
            if (!err) {
                // 如果没有错误，则还在页面
                if (this.$xxRouter.location.pathname === '/' && !this.$xxRouter.location.params.url) {
                    return;
                }
                let url = `${this.$xxRouter.location.pathname}${this.$xxRouter.location.search}`;
                let targetUrl = this.$xxRouter.location.pathname;
                if (this.$xxRouter.location.pathname === '/' && this.$xxRouter.location.params.url) {
                    url = decodeURIComponent(this.$xxRouter.location.params.url);
                    targetUrl = url;
                }
                const targetName = targetUrl.endsWith('.html') ? targetUrl.slice(0, -5) : targetUrl;
                const menu = this.setActiveMenusByLocation(this.$xxRouter.location) || {};
                if (!this.$xxRouter.activePage || (this.$xxRouter.activePage && this.$xxRouter.activePage.url !== url)) {
                    // 根据菜单打开新的页面
                    this.linkTo({ ...menu, url, targetName }, true);
                }
            }
        });

        this.initMenuData();
        if (!['development', 'dev'].includes(process.env.NODE_ENV)) {
            this.getPortalInitData();
            // this.getBlockUrlsTransaction(); // 可以在远端配置 block 页面
        }
    },
    // beforeDestroy() {
    //     this.clearBlockUrlsTransaction();
    // },
    methods: {
        async fetchPortal(mod) {
            const osgFePc = await fetchHornConfig(mod)('');
            return osgFePc;
        },
        isPageBlocked(url) {
            return this.blockedUrls.some((path) => url.indexOf(path) === 0);
        },
        // getBlockUrlsData() {
        //     this.fetchPortal('osg_fe_pc').then(({ blockedUrls = [] }) => {
        //         this.blockedUrls = blockedUrls;
        //     });
        // },
        // getBlockUrlsTransaction() {
        //     this.timerId = setInterval(() => this.getBlockUrlsData(), 5 * 60 * 1000); // 每5分钟请求一次
        // },
        // clearBlockUrlsTransaction() {
        //     clearInterval(this.timerId);
        // },
        getPortalInitData() {
            this.fetchPortal('osg_fe_pc').then(({ pathMap = {}, blockedUrls = [] }) => {
                this.pathMap = pathMap;
                this.blockedUrls = blockedUrls;
            });
        },
        async initMenuData() {
            try {
                this.dataLoading = true;
                if (this.$xxPlatform.accountTypeByPath === ACCOUNT_TYPE.SUPPLIER) {
                    await this.$store.dispatch("getSupplierMenuListApi");
                    this.menuData = formatMenuSource(this.$store.getters.supplierMenuList);
                } else {
                    this.menuData = formatRenxiaoMenuSource(menuList);
                }
                // const resp = await hGet('/api/auth/mallsso/getEmpSortedMenu');
                // this.userInfo = { uid: resp.uid, name: resp.name };

                // this.showFirstMenuIds = get(resp, 'firstMenu.showMenuList', []).map(({ id }) => id);
                // this.hideFirstMenuIds = get(resp, 'firstMenu.hideMenuList', []).map(({ id }) => id);

                // this.menuList = get(resp, 'menuList', []).map((item) => ({ ...item, menus: item.remoteMenus }));
                this.$$event.$emit('$menu.load', null, this);
            } catch (err) {
                let message = '';
                const { data = {} } = err;
                if (data.code === 2001) {
                    message = '您的账号没有权限';
                }
                console.error(err);
                this.$$event.$emit('$menu.load', err, this);
                this.$message.error(message || '菜单获取失败，请刷新重新获取');
            } finally {
                this.dataLoading = false;
            }
        },
        initMenuList(menuList = []) {
            let menuData = [];
            let copyMenuList = [...menuList];
            if (copyMenuList && copyMenuList.length) {
                // 先做排序，把topmenu的放在最上边，不改变topmenu 本身的顺序
                const topMenuIndex = copyMenuList.findIndex((m) => m.url.indexOf('topmenu://') >= 0);
                if (topMenuIndex >= 0) {
                    const topMenu = copyMenuList[topMenuIndex].menus || [];
                    copyMenuList.splice(topMenuIndex, 1);
                    copyMenuList = topMenu.concat(copyMenuList);
                }

                copyMenuList.forEach((item) => {
                    if (item.url && item.url.indexOf('topmenu://') >= 0) {
                        const { category, position, url } = parseFirstMenuUrl(item.url);
                        this.$set(this.firstMenusMap, item.id, {
                            category,
                            url,
                            id: item.id,
                            level: 1,
                            subMenus: [],
                            title: item.title,
                            position: position || 'top',
                            isSeparator: category === 'separator',
                        });
                        menuData.push(this.firstMenusMap[item.id]);
                    } else {
                        const { category } = parseSecondMenuUrl(item.url);
                        const topMenu = menuData.find((menu) => menu.category === category);
                        if (topMenu) {
                            const secondMenu = this.parseSecondMenu(item, topMenu.id);
                            // FIXME: 特殊情况转换，需要判断是否能作为子菜单，且子菜单列表为空
                            if (secondMenu.isLeaf && secondMenu.subMenus.length === 0) {
                                const thirdMenu = { ...secondMenu, parent: secondMenu.id, level: 3 };
                                delete thirdMenu.subMenus;
                                secondMenu.subMenus = [thirdMenu];
                            }
                            topMenu.subMenus.push(secondMenu);
                        }
                    }
                });
            }
            // 过滤
            menuData = menuData.filter((topMenu) => topMenu.subMenus && topMenu.subMenus.length > 0);
            // 然后排个序
            let orderIdx = 0;
            const firstMenuOrderMap = {};
            // eslint-disable-next-line
            this.showFirstMenuIds.forEach(id => {
                // eslint-disable-next-line no-plusplus
                firstMenuOrderMap[id] = orderIdx++;
            });
            // eslint-disable-next-line
            this.hideFirstMenuIds.forEach(id => {
                // eslint-disable-next-line no-plusplus
                firstMenuOrderMap[id] = orderIdx++;
            });
            menuData.sort((menu1, menu2) => firstMenuOrderMap[menu1.id] - firstMenuOrderMap[menu2.id]);
            return menuData;
        },
        parseSecondMenu(item, parent = -1) {
            if (item.url.indexOf('smenu://') >= 0) {
                const { category, url } = parseSecondMenuUrl(item.url);
                this.$set(this.secondMenusMap, item.id, {
                    parent,
                    category,
                    level: 2,
                    id: item.id,
                    name: item.title,
                    title: item.title,
                    target: item.type === 1 ? '_self' : '_blank',
                    isLeaf: !!(url && url.indexOf('|') === 0),
                    url: url.indexOf('|') === 0 ? url.slice(1) : url,
                    subMenus: item.menus && item.menus.length ? item.menus.map((m) => this.parseSecondMenu(m, item.id)) : [],
                });
                return this.secondMenusMap[item.id];
            }
            this.$set(this.thirdMenusMap, item.id, {
                parent,
                level: 3,
                id: item.id,
                name: item.title,
                title: item.title,
                url: item.url,
                target: item.type === 1 ? '_self' : '_blank',
            });

            this.$set(this.thirdMenusUrlMap, this.parseUrlHelper(item.url), { ...item });
            return this.thirdMenusMap[item.id];
        },
        setFirstMenuActive(id = -1) {
            this.activeFirstMenuId = id;
        },
        setSecondMenuActive(id = -1) {
            this.activeSecondMenuId = id;
        },
        toggleSecondMenu(show) {
            if (typeof show === 'boolean') {
                this.showSecondMenu = show;
            } else {
                this.showSecondMenu = !this.showSecondMenu;
            }
            // 非当前tab的二级菜单则需要清除二级菜单
            if (!this.showSecondMenu && this.activeSecondMenuId !== this.reflectActiveSecondMenuId) {
                this.setSecondMenuActive();
            }
        },
        toggleThirdMenu(show) {
            if (typeof show === 'boolean') {
                this.showThirdMenu = show;
            } else {
                this.showThirdMenu = !this.showThirdMenu;
            }
            // 非当前tab的二级菜单则需要清除二级菜单
            if (!this.showThirdMenu && this.activeSecondMenuId !== this.reflectActiveSecondMenuId) {
                this.setSecondMenuActive();
            }
        },
        toShortCut() {
            if (this.settingMenu) {
                this.linkTo(this.settingMenu);
            }
        },
        linkTo(menu, force = false) {
            if (!force && (menu.target === '_blank' || isIosMobileAndData(menu.url))) {
                const newWin = window.open();
                if (newWin) {
                    ['lsfe/skeleton/pages', 'lsfe/skeleton/activePage'].forEach((key) => newWin.sessionStorage.removeItem(key));
                    newWin.location.href = menu.url;
                }
                return;
            }
            let _url = menu.url;
            Object.keys(this.pathMap).some((path) => {
                // 必须是开头
                if (_url.indexOf(path) === 0) {
                    _url = this.pathMap[path];
                    return true;
                }
                return false;
            });
            if (_url !== menu.url) {
                const mappedMenu = this.getActiveMenu(_url, false);
                if (mappedMenu) {
                    menu.title = mappedMenu.title;
                }
            }
            let target = menu.targetName;
            if (!target) {
                target = menu.url.endsWith('.html') ? menu.url.slice(0, -5) : menu.url;
            }
            this.linkToWithOpenNewTab({ ...menu, target, isNewTab: true });
        },
        linkToWithOpenNewTab(options) {
            const { pageIndex } = this.$xxRouter.loader.getNewPageIndexAndTargetName(options);
            // 新页面将会被锁定
            if (pageIndex === -1 && this.isPageBlocked(options.url)) {
                this.$alert('系统升级中，本页面无法访问，即将跳转', '温馨提示', {
                    confirmButtonText: '我知道了',
                    showClose: false,
                }).then(() => this.$xxRouter.loader.openNewTab({ ...options, url: '/base/undone.html', title: '系统维护' }));
            }
            this.$xxRouter.loader.openNewTab(options);
        },
        getMeuByUrl(url, withReflect = false) {
            if (!withReflect) {
                return this.getActiveMenu(url);
            }
            return this.reflectActiveMenuDisplay(this.getActiveMenu(url));
        },
        setActiveMenusByLocation(location) {
            if (location.pathname === '/' && !location.params.url) {
                this.toggleSecondMenu(false);
            }
            return this.reflectActiveMenuDisplay(this.getActiveMenu(this.getActiveUrl(location)));
        },
        getActiveUrl(location) {
            if (location.pathname === '/' && location.params.url) {
                return decodeURIComponent(location.params.url);
            }
            return location.pathname;
        },
        getActiveMenu(activeUrl, usePathMap = true) {
            let _url = activeUrl;
            if (activeUrl === '/') {
                return null;
            }
            // 使用 pathMap 做映射
            if (usePathMap) {
                Object.keys(this.pathMap).some((path) => {
                    // 必须是开头
                    if (_url.indexOf(path) === 0) {
                        _url = this.pathMap[path];
                        return true;
                    }
                    return false;
                });
            }
            // 获取全部3级子菜单的权重
            const weightedMenuList = this.allThirdMenusList.map((menu) => ({ ...menu, weight: getWeight(menu.url, _url) }));
            let maxIdx = -1;
            let maxVal = -Infinity;
            // 取最大权重的菜单
            weightedMenuList.forEach((menu, index) => {
                if (menu.weight > maxVal) {
                    maxIdx = index;
                    maxVal = menu.weight;
                }
            });
            if (maxIdx === -1) {
                return null;
            }
            return weightedMenuList[maxIdx];
        },
        // 反射菜单展示
        reflectActiveMenuDisplay(menu) {
            if (!menu) {
                return null;
            }
            // 找二级菜单
            const lv2Menu = this.secondMenusMap[menu.parent];
            if (!lv2Menu) {
                return null;
            }
            // 找一级菜单
            const lv1Menu = this.firstMenusMap[lv2Menu.parent];
            if (!lv1Menu) {
                return null;
            }
            // 设置激活状态
            this.setFirstMenuActive(lv1Menu.id);
            this.setSecondMenuActive(lv2Menu.id);
            // 记录当前状态
            this.reflectActiveSecondMenuId = lv2Menu.id;
            /**
             * 手机上点tab不要自动弹出左侧菜单。
             */
            if (!this.isMobile) this.toggleSecondMenu(true);
            return menu;
        },
        parseUrlHelper(url) {
            return (url.split('?')[0] || '').replace(/^https?:\/\/[^/]+/, '').replace('-alias', '');
        },
    },
};
</script>
